var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "uni-circle-progress" }, [
    _c(
      "div",
      { staticClass: "progress-circle" },
      [
        _c(
          "el-tooltip",
          {
            staticClass: "item",
            attrs: {
              effect: "dark",
              content: `${_vm.datas.title}(${_vm.datas.current}/${_vm.datas.total})`,
              placement: "top-start",
            },
          },
          [
            _c("div", { staticClass: "title-box" }, [
              _c("span", { staticClass: "tit" }, [
                _vm._v(_vm._s(_vm.datas.title)),
              ]),
              _vm._v(" ("),
              _c("span", { staticClass: "primary" }, [
                _vm._v(_vm._s(_vm.datas.current)),
              ]),
              _vm._v("/"),
              _c("span", [_vm._v(_vm._s(_vm.datas.total || 0))]),
              _vm._v(") "),
            ]),
          ]
        ),
        _c("span", { staticClass: "hr" }),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "progress-box" },
      [
        _c("el-progress", {
          attrs: {
            strokeWidth: 4,
            type: "circle",
            width: _vm.progressWidth,
            percentage: _vm.datas.percent,
            color: _vm.color,
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }